import React,{useEffect,useState} from 'react';
import {Link,useParams} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ReviewShareActions from '../components/reviews/ReviewShareActions';
import {getReviewLink} from '../services/reviewLinkService';

const {FiMapPin,FiStar,FiImage}=FiIcons;

function BusinessImage({business}) {
  return (
    <div className="relative isolate flex min-h-56 items-center justify-center overflow-hidden bg-[#101c2d] sm:min-h-80">
      {business.image_url ? (
        <>
          <img
            src={business.image_url}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 -z-10 h-full w-full scale-110 object-cover opacity-30 blur-3xl"
          />
          <img
            src={business.image_url}
            alt={`${business.business_name} business photo or logo`}
            className="relative max-h-[min(70vw,28rem)] w-auto max-w-full object-contain px-4 py-5 sm:max-h-[28rem] sm:px-8 sm:py-8"
          />
        </>
      ) : (
        <SafeIcon icon={FiImage} className="h-16 w-16 text-[#3fc0fa]" />
      )}
    </div>
  );
}

export default function BusinessReviewPage() {
  const {slug}=useParams();
  const [business,setBusiness]=useState(null);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState('');
  const shareUrl=`${window.location.origin}/${encodeURIComponent(slug)}/review`;

  useEffect(()=> {
    let active=true;
    setLoading(true);
    setBusiness(null);
    setError('');
    getReviewLink(slug)
      .then((record)=> {if (active) setBusiness(record);})
      .catch(()=> {if (active) setError('This review page could not be loaded right now.');})
      .finally(()=> {if (active) setLoading(false);});
    return ()=> {active=false;};
  },[slug]);

  return (
    <main className="min-h-screen bg-[#0b1423] px-4 pb-24 pt-12 text-white sm:px-6 sm:pt-20">
      <div className="mx-auto max-w-3xl">
        {loading && <p className="text-slate-300">Loading business…</p>}
        {!loading && (error || !business) && (
          <div className="rounded-3xl border border-white/10 bg-[#19283d] p-8">
            <h1 className="text-3xl font-black">Review page unavailable</h1>
            <p role="alert" className="mt-3 text-slate-300">{error || 'We could not find a business at this link.'}</p>
            <Link to="/reviews" className="mt-6 inline-block font-bold text-[#3fc0fa]">Find a business</Link>
          </div>
        )}
        {business && !loading && (
          <div className="overflow-hidden rounded-[2rem] border border-white/10 bg-[#19283d] shadow-2xl">
            <BusinessImage business={business} />
            <div className="p-6 sm:p-10">
              <div className="mb-4 flex gap-1 text-[#f8b86a]" aria-label="Five decorative stars">
                {Array.from({length: 5},(_,index)=> (
                  <SafeIcon key={index} icon={FiStar} className="h-6 w-6 fill-current" />
                ))}
              </div>
              <h1 className="text-3xl font-black leading-tight tracking-tight sm:text-5xl">{business.business_name}</h1>
              {business.address && (
                <p className="mt-4 flex items-start gap-2 text-slate-300">
                  <SafeIcon icon={FiMapPin} className="mt-1 shrink-0 text-[#3fc0fa]" />
                  {business.address}
                </p>
              )}
              <p className="mt-7 text-lg leading-relaxed text-slate-200">Share your review page with customers.</p>
              <ReviewShareActions business={business} url={shareUrl} />
            </div>
          </div>
        )}
      </div>
    </main>
  );
}